import AddressDisplay from 'common/components/address/AddressDisplay';
import CreditCardDisplay from 'profile/creditCard/CreditCardDisplay';

const Payment = (props) => {
  const { reservationCart, currentStep, onEdit } = props;
  const handleEdit = (e) => {
    e.preventDefault();
    onEdit('payment');
  };
  if (currentStep === 'complete' && reservationCart.virtualCart.total !== 0) {
    return (
      <div>
        <div>
          <div>Payment info</div>
          <div>
            <CreditCardDisplay creditCard={reservationCart.creditCard} />
          </div>
        </div>
        <a onClick={handleEdit}>Edit</a>
      </div>
    );
  }
  if (currentStep === 'complete' && reservationCart.virtualCart.total === 0) {
    return (
      <div>
        <div>
          <div>Payment info</div>
          <div>
            <AddressDisplay address={reservationCart.billTo} />
          </div>
        </div>
        <a onClick={handleEdit}>Edit</a>
      </div>
    );
  }
  return null;
};

export default Payment;
